// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeOrderPaymentDisplayType {
  Transfer = "TRANSFER",
  CardStandard = "CARD_STANDARD",
  CardGooglePay = "CARD_GOOGLE_PAY",
  CardApplePay = "CARD_APPLE_PAY",
  Terminal = "TERMINAL",
}
export default ChargeOrderPaymentDisplayType;
